import 'intersection-observer';

const onPaginationNodeClick = ({ target }) => {
    const { scrollTo } = target.dataset;
    const scrollToNode = document.querySelector(`section.section#${scrollTo}`);

    if (scrollToNode !== null) {
        const top = scrollToNode.offsetTop;

        window.scrollTo({
            top,
            left: 0,
            behavior: 'smooth'
        });
    }
};

const createNode = (id) => {
    const node = document.createElement('div');

    node.classList.add('sections-pagination--item');
    node.dataset.scrollTo = id;
    node.addEventListener('click', onPaginationNodeClick);

    return node;
};

export class PaginationController {
    constructor() {
        this.wrap = document.querySelector('.sections-pagination--wrap');
        this.sections = [...document.querySelectorAll('section.section')];
        this.paginationItems = [];
        this.darkModeSections = ['fans', 'facts'];
    }

    init() {
        const { sections, wrap } = this;

        this.paginationItems = sections.map((el) => {
            const { id } = el;
            const paginationItem = createNode(id);

            wrap.appendChild(paginationItem);

            return paginationItem;
        });

        this.initObserve();
    }

    setAppearance(id) {
        const isDarkMode = this.darkModeSections.includes(id);
        const action = isDarkMode ? 'add' : 'remove';

        this.wrap.classList[action]('dark');
    }

    setActive(id) {
        this.paginationItems.forEach((el) => {
            const { scrollTo } = el.dataset;
            const isActive = scrollTo === id;
            const action = isActive ? 'add' : 'remove';

            el.classList[action]('active');
        });
    }

    initObserve() {
        const obs = new IntersectionObserver((entries) => {
            const intersected = entries.find((entry) => entry.isIntersecting) || null;

            if (intersected !== null) {
                const { id } = intersected.target;

                this.setActive(id);
                this.setAppearance(id);
            }
        }, {
            threshold: [0.1, 0.8]
        });

        this.sections.forEach((el) => {
            obs.observe(el);
        });
    }
}
